import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { Can, useAuth, Spinner } from '@iq/react-components';
import SwaggerUI from 'swagger-ui-react';
import config from '../../config';
import 'swagger-ui-react/swagger-ui.css';
import {
  getCollaborationServiceDocuments,
  getAuthServiceDocuments,
  getEventServiceDocuments,
  getDataServiceDocuments,
  getSiteServiceDocuments,
  getFileServiceDocuments,
  getModelServiceDocuments,
  getIntegrationServiceDocuments,
} from '../../services';
import { capitalize } from '../../utils';

const getSiteId = (request) => {
  const url = new URL(request.url, globalThis.location.origin);
  return url.searchParams.get('site') || 'unknown_site';
};

const handleBinaryResponse = (response, site, fileName) => {
  const contentType = response.headers['content-type'];
  if (contentType?.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
    const blob = new Blob([response.data], { type: contentType });
    const downloadUrl = globalThis.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `${site}-${fileName}`;
    document.body.append(a);
    a.click();
    a.remove();
    globalThis.URL.revokeObjectURL(downloadUrl);

    response.data = null;
    response.text = '';
    return response;
  }
  return response;
};

const ApiDocumentView = ({
  match: {
    params: { id: service },
  },
}) => {
  const { getAccessToken } = useAuth();
  const [documentation, setDocumentation] = useState();
  const [loading, setLoading] = useState(true);
  const serviceName = service.split('-')[0];
  let siteId = '';

  const { services } = config;

  const getEndpoint = () => {
    const endPointName = serviceName.split('-')[0];
    const [, { endpoint }] = Object.entries(services).find((index) => index.includes(endPointName));
    return endpoint;
  };

  const serviceEndpoints = {
    auth: getAuthServiceDocuments,
    collaboration: getCollaborationServiceDocuments,
    data: getDataServiceDocuments,
    event: getEventServiceDocuments,
    file: getFileServiceDocuments,
    model: getModelServiceDocuments,
    site: getSiteServiceDocuments,
    integration: getIntegrationServiceDocuments,
  };

  const getApiDocumentation = async (endpoint) => {
    const getServiceDocumentation = serviceEndpoints[serviceName];
    if (getServiceDocumentation) {
      try {
        const serviceDocumentation = await getServiceDocumentation();
        setLoading(false);
        if (serviceDocumentation) {
          const parsedDocumentationWithServer = {
            ...serviceDocumentation,
            servers: [{ url: `${endpoint}` }],
          };
          setDocumentation(parsedDocumentationWithServer);
        } else {
          throw new Error('Service docs not found');
        }
      } catch {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    const endpoint = getEndpoint();
    getApiDocumentation(endpoint);
  }, []);

  if (loading) {
    return (
      <div className="docs-spinner">
        <Spinner />
      </div>
    );
  }

  if (documentation && !loading) {
    return (
      <div>
        <div className="back-link">
          <NavLink
            title={'Back'}
            exact
            to={'/api-docs'}
          >
            {'< Back'}
          </NavLink>
        </div>

        <div className="items">
          <Can permission={`${serviceName}Docs/Read`}>
            <SwaggerUI
              spec={documentation}
              docExpansion="list"
              syntaxHighlight={{ activated: false }}
              tryItOutEnabled
              requestInterceptor={async (request) => {
                const token = await getAccessToken();
                request.headers.Authorization = `Bearer ${token}`;
                request.withCredentials = true;

                const siteIdFromRequest = getSiteId(request);
                if (siteIdFromRequest) {
                  siteId = siteIdFromRequest;
                }

                return request;
              }}
              responseInterceptor={(response) => {
                handleBinaryResponse(response, siteId, 'exported_components.xlsx');
                return response;
              }}
            />
          </Can>
        </div>
      </div>
    );
  }
  return (
    <div>
      Documentation for {capitalize(serviceName)} service is currently unavailable. Please try again
      later.
    </div>
  );
};

export default ApiDocumentView;
